(function () {
  'use strict';

  function initSlider(slider) {
    if (slider.dataset.rrInit) return;
    slider.dataset.rrInit = '1';

    var track = slider.querySelector('.rr-card-slider__track');
    var fill = slider.querySelector('.rr-card-slider__progress-fill');
    var btnPrev = slider.querySelector('.rr-card-slider__btn--prev');
    var btnNext = slider.querySelector('.rr-card-slider__btn--next');
    var slides = slider.querySelectorAll('.rr-card-slider__slide');
    var total = slides.length;
    var current = 0;

    if (!track || total === 0) return;

    function setProgress(idx) {
      current = Math.max(0, Math.min(idx, total - 1));
      if (fill) fill.style.width = ((current + 1) / total * 100) + '%';
    }
    setProgress(0);

    function goTo(idx) {
      idx = Math.max(0, Math.min(idx, total - 1));
      var w = track.offsetWidth;
      if (w === 0) return;
      track.scrollLeft = idx * w;
      setProgress(idx);
    }

    // Native scroll update
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var w = track.offsetWidth;
        if (w > 0) setProgress(Math.round(track.scrollLeft / w));
      }, 80);
    }, { passive: true });

    // Buttons
    function setupBtn(btn, dir) {
      if (!btn) return;
      btn.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        goTo(current + dir);
      });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      });
      btn.addEventListener('touchstart', function (e) {
        e.stopPropagation();
      }, { passive: true });
    }

    setupBtn(btnPrev, -1);
    setupBtn(btnNext, 1);

    // Tapping centre of image should go to product
    // We handle this by making the track itself navigate on tap
    // only if the scroll position didn't change (i.e. it was a tap not a swipe)
    var touchStartX = 0;
    var touchStartScrollLeft = 0;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartScrollLeft = track.scrollLeft;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (e.target.closest && e.target.closest('.rr-wish')) return;
      var dx = Math.abs(e.changedTouches[0].clientX - touchStartX);
      var scrolled = Math.abs(track.scrollLeft - touchStartScrollLeft);
      // If barely moved = tap = navigate to product
      if (dx < 8 && scrolled < 8) {
        var link = slider.querySelector('.rr-card-slider__product-link');
        if (link && link.href) window.location.href = link.href;
      }
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('.rr-card-slider').forEach(initSlider);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initAll)
    : initAll();

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.classList && n.classList.contains('rr-card-slider')) initSlider(n);
          else if (n.querySelectorAll) n.querySelectorAll('.rr-card-slider').forEach(initSlider);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

})();
